import util from '../util'

let controller = 'v1/ListaPositiva'

export default Object.assign({}, util.GetCrud(controller, null), {
  Listar: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + "/Listar", dto)
  },
  GerarExcelRelatorioListaPositiva: function (dto) {
    return util.Axios.GetAll(controller + '/lista-positiva-xlsx', dto)
  }
})